import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import { IconAdd } from '../../../../components/develop-nilton-components/IconAdd';
import { IconConcluido } from '../../../../components/develop-nilton-components/IconConcluido';
import { IconDetails } from '../../../../components/develop-nilton-components/IconDetails';
import { IconEdit } from '../../../../components/develop-nilton-components/IconEdit';
import { Td, Tr } from '../../../../components/develop-nilton-components/TablePadrão';
import { SpinnerLoading } from '../../../../components/SpinnerLoading';
import api from '../../../../services/api';
import { PropsTbodyTable } from '../types';
import { ModalHomologar } from './ModalHomologar';
import { ModalVisualizarProjeto } from './ModalVisualizarProjeto';

export function TbodyTableGeral({
  headWidth, projetos, index, handleProjetos, meta,
}:PropsTbodyTable) {
  const projeto = { ...projetos, materials: projetos?.materiais.map((item) => ({ qtd: item.qtd, material: item.material })) };
  const history = useHistory();
  function handleRedirect() {
    history.push({
      pathname: '/homologar_pro/editar',
      state: {
        projeto,
      },
    });
  }

  const [isOpenModalVisualizarProjeto, setIsOpenModalVisualizarProjeto] = useState(false);
  function handleIsOpenModalVisualizarProjeto() {
    setIsOpenModalVisualizarProjeto(!isOpenModalVisualizarProjeto);
  }

  const [load, setLoad] = useState(false);

  async function handleHomologar() {
    setLoad(true);
    await api.put(`/projects/${projeto.id}`, { homologado: "T" });
    if (meta?.current_page) {
      await handleProjetos(meta?.current_page);
    }
    setLoad(false);
  }

  return (
    <Tr>
      <Td width={headWidth[0]}>{index}</Td>
      <Td width={headWidth[1]}>{projetos.nome}</Td>
      <Td width={headWidth[2]}>
        {projeto.pedagogo.name}
      </Td>
      <Td width={headWidth[3]}>
        <ReactTooltip />
        <div className="mr-3" onClick={handleIsOpenModalVisualizarProjeto}>
          <IconDetails tooltipMessage="Detalhes do projeto" cursor />
        </div>
        {(!projetos.homologado) && (
        <div>
          {load ? <SpinnerLoading /> : (
            <div onClick={handleHomologar}>
              <IconAdd
                cursor
                size={30}
                tooltipMessage="Homologar"
                color="text-primary"
              />
            </div>
          )}
        </div>
        )}
        {projetos.homologado === "T" && (
        <IconConcluido
          size={30}
          tooltipMessage="Homologado"
        />
        )}
        <ModalVisualizarProjeto id={projetos.id} isOpen={isOpenModalVisualizarProjeto} handleIsOpen={handleIsOpenModalVisualizarProjeto} />
      </Td>
    </Tr>
  );
}
